const state = {
  serverUrl: null,
  SubLocationId: 0,
}

const getters = {
  getServerUrl: state => state.serverUrl,
  getCurrentSubLocationId: state => state.SubLocationId
}

const actions = {
  async setServerUrl ({ commit }, serverUrl) {
    await commit('setUrl', serverUrl)
  },
  async setCurrentSubLocationId ({ commit }, index) {
    await commit('setSubLocationId', index)
  },
}

const mutations = {
  setUrl (state, serverUrl) {
    state.serverUrl = serverUrl
  },
  setSubLocationId (state, index) {
    state.SubLocationId = index
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
